import SearchPostCode from "./SearchPostCode";

export default SearchPostCode;
